var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdminDeleteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 18.3327H6.33333C5.41286 18.3327 4.66667 17.5865 4.66667 16.666V5.83268H3V4.16602H6.33333V3.33268C6.33333 2.41221 7.07953 1.66602 8 1.66602H13C13.9205 1.66602 14.6667 2.41221 14.6667 3.33268V4.16602H18V5.83268H16.3333V16.666C16.3333 17.5865 15.5871 18.3327 14.6667 18.3327ZM6.33333 5.83268V16.666H14.6667V5.83268H6.33333ZM8 3.33268V4.16602H13V3.33268H8ZM13 14.9993H11.3333V7.49935H13V14.9993ZM9.66667 14.9993H8V7.49935H9.66667V14.9993Z",
    fill: "#354ACD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdminDeleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adminDeleteIcon.8c3d1edff38a6a45db4c8fdbf970e17a.svg";